
namespace TabAurous.Production{

    @Serenity.Decorators.registerClass()
    export class WIPMovementSelectGridForMerging extends _Ext.GridBase<WIPMovementRow, any> {
       
        protected getColumnsKey() { return 'Production.WIPMovement'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return WIPMovementSelectForMergingService.baseUrl; } 
        private autoSize;


        constructor(container: JQuery, options) {
            super(container, options);
            (this.view.params as TransactionRequest).VoucherTypeId = 76;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this 
            });
        }

        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));

            columns.forEach(column => {
                if (column.sourceItem && column.sourceItem.editLink)
                    column.format = undefined;
            });
            return columns;
        };

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): WIPMovementRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            
            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}